import React, { createContext, useState, useContext } from 'react'

const CotizationTaxesContext = createContext()

export const FreeTaxesProvider = ({ children }) => {
  const [freeTaxes, setFreeTaxes] = useState(false)
  const [isChanged, setIsChanged] = useState(false)

  return (
    <CotizationTaxesContext.Provider
      value={{ freeTaxes, setFreeTaxes, isChanged, setIsChanged }}>
      {children}
    </CotizationTaxesContext.Provider>
  )
}

export const useFreeTaxes = () => {
  return useContext(CotizationTaxesContext)
}
